import axios from "axios";

const API = "/api";
const auth = () => {
  const token = localStorage.getItem("token");
  return token ? { headers: { Authorization: `Bearer ${token}` } } : {};
};

export const divulgacaoApi = {
  listar: () => axios.get(`${API}/sms/links-divulgacao`, auth()).then((r) => r.data),
  gerar: (plataforma) =>
    axios.post(`${API}/sms/links-divulgacao/${plataforma}`, {}, auth()).then((r) => r.data),
  criarCustom: (nome, tipo) =>
    axios.post(`${API}/sms/links-divulgacao-custom`, { nome, tipo }, auth()).then((r) => r.data),
  metricas: (token, dias) =>
    axios.get(`${API}/sms/links-divulgacao/${token}/metricas?dias=${dias}`, auth()).then((r) => r.data),
  deletar: (token) =>
    axios.delete(`${API}/sms/links-divulgacao/${token}`, auth()).then((r) => r.data),
};

// QR Code dos links (26/10/2026): o QR leva ao mesmo endereço do link, então
// quem escaneia conta no mesmo quadro. As rotas são autenticadas — a imagem
// vem como blob (um <img src> direto não manda o token).
const blobDoQr = (token) =>
  axios.get(`${API}/sms/links-divulgacao/${token}/qrcode.png`, { ...auth(), responseType: "blob" }).then((r) => r.data);

export async function qrComoDataUri(token) {
  const blob = await blobDoQr(token);
  return new Promise((resolve, reject) => {
    const leitor = new FileReader();
    leitor.onloadend = () => resolve(leitor.result);
    leitor.onerror = reject;
    leitor.readAsDataURL(blob);
  });
}

function salvarArquivo(blob, nome) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = nome;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 2000);
}

const arquivoDe = (nome) =>
  String(nome || "link").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase()
    .replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "") || "link";

export async function baixarPngLink(token, nome) {
  salvarArquivo(await blobDoQr(token), `qr-${arquivoDe(nome)}.png`);
}

/** Cartões na impressora do caixa (fila de impressão, igual às mesas). `tokens` vazio = todos. */
export const imprimirLinks = (tokens) =>
  axios.post(`${API}/sms/links-divulgacao-imprimir`, { tokens: tokens?.length ? tokens : null }, auth());

/** `tokens` vazio = todos os links da loja. */
export async function baixarPdfLinks(tokens, nome) {
  const { data } = await axios.post(`${API}/sms/links-divulgacao-qrcodes.pdf`,
    { tokens: tokens?.length ? tokens : null }, { ...auth(), responseType: "blob" });
  salvarArquivo(data, tokens?.length === 1 ? `qr-${arquivoDe(nome)}.pdf` : "qr-codes-links.pdf");
}
